import { Provider } from 'react-redux';

import { HelmetProvider } from 'react-helmet-async';
import App from './App';

import { store } from './Redux/store';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { addConfig } from './Redux/actions';

const container = document.getElementById('root');
const root = createRoot(container);

// config is needed for the whole app, call it first no matter what page we are on
async function init() {
  const res = await fetch('/json/content/config.json');
  const config = await res.json();
  addConfig(store.dispatch, config);

  root.render(
    <StrictMode>
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
    </StrictMode>,
  );
}

init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
